// import log from 'salvo-lite/log'
import HcSticky from 'hc-sticky'
import Helpers from '../helpers/Helpers'

class StickyElem {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._sticky = null
        this._header = document.querySelector('[data-header]')
        this._options = Object.assign({
            top: 0,
            bottom: 0,
            onStart: () => {
                this._elem.classList.remove('just-become-unsticky')
                Helpers.nextFrame(() => {
                    this._elem.classList.add('can-transition')
                })
            },
            onStop: () => {
                this._elem.classList.add('just-become-unsticky')
                Helpers.nextFrame(() => {
                    this._elem.classList.remove('can-transition')
                })
                setTimeout(() => {
                    this._elem.classList.remove('just-become-unsticky')
                }, 500)
            },
            events: true
        }, JSON.parse(this._elem.dataset.sticky || '{}'))
        // log.debug(this.constructor.name, 'Constructed', this)

        if (typeof this._options.top === 'string' && document.querySelector(this._options.top)) {
            this._options.top = document.querySelector(this._options.top).getBoundingClientRect().height
        }

        if (!this._options.dontInit) {
            this.init()
        }
    }

    onInit () {
    }

    init () {
    // log.debug(this.constructor.name, 'Initiating')
        this._sticky = new HcSticky(this._elem, this._options)

        if (this._options.events) {
            this._attachEvents()
        }
    // log.debug(this.constructor.name, 'Initiated')
    }

    _attachEvents () {
        document.addEventListener('update-sticky', () => {
            this._sticky.update()
        })

        document.addEventListener('header-visible', () => {
            this._sticky.update({
                top: this._header.getBoundingClientRect().height + this._options.top
            })
        })

        document.addEventListener('header-hide', () => {
            this._sticky.update({
                top: this._options.top
            })
        })

        document.addEventListener('header-reset', () => {
            this._sticky.update({
                top: this._options.top
            })
        })
    }
}

export default StickyElem



// WEBPACK FOOTER //
// ./src/resources/scripts/components/StickyElem.js